import type { EventDefinition } from './navigation';

export type DemoBannerHowMorfiWorksClickedProperties = Record<string, never>;

export const DEMO_BANNER_HOW_MORFI_WORKS_CLICKED: EventDefinition<DemoBannerHowMorfiWorksClickedProperties> =
  {
    name: 'demo_banner_how_morfi_works_clicked',
  };
